export const API_BASE = process.env.REACT_APP_API_URL || "/api";

function authHeaders() {
  const token = localStorage.getItem("token");
  return token
    ? { "Content-Type": "application/json", Authorization: `Bearer ${token}` }
    : { "Content-Type": "application/json" };
}

export async function api(path, opts = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: authHeaders(),
    ...opts,
  });
  let data = {};
  try { data = await res.json(); } catch (e) {}
  if (!res.ok) {
    const err = new Error(data.message || `HTTP ${res.status}`);
    err.status = res.status;
    err.data = data;
    if (res.status === 401 && SESSION_END_CODES.includes(data.code)) endSession(data.code);
    throw err;
  }
  return data;
}

// The server tags a dead login's 401 with one of these codes. Only these sign
// the person out: other 401s (e.g. "Current password is incorrect") must not.
export const SESSION_END_CODES = ["session_expired", "session_revoked", "session_invalid"];
export const SIGNED_OUT_REASON_KEY = "dfhr.signedOutReason";

// Sign out and go to the sign-in page, leaving the reason for it to show, so
// people see "your login expired" instead of an unexplained bounce.
export function endSession(code) {
  try { sessionStorage.setItem(SIGNED_OUT_REASON_KEY, code); } catch (e) {}
  logout();
  if (window.location.pathname !== "/login") window.location.assign("/login");
}

// Expiry time (ms) from the token's exp claim, or null if unreadable.
export function tokenExpiresAt(token = localStorage.getItem("token")) {
  if (!token) return null;
  try {
    const part = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const { exp } = JSON.parse(atob(part));
    return typeof exp === "number" ? exp * 1000 : null;
  } catch (e) {
    return null;
  }
}

export function logout() {
  ["token", "role", "username", "userID", "email"].forEach((k) => localStorage.removeItem(k));
}

export function setSession({ token, role, username, userID, email }) {
  if (token) localStorage.setItem("token", token);
  if (role) localStorage.setItem("role", role);
  if (username) localStorage.setItem("username", username);
  if (userID) localStorage.setItem("userID", userID);
  if (email) localStorage.setItem("email", email);
}
